import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import EditQueryFilter from './EditQueryFilter';
import CustomLoader from '../../../common/CustomLoader';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactJson from 'react-json-view';
import showAlert from '../../../../common/utils/alert';
import {
  DEFAULT_COLLECTION_FILTERS,
  DEFAULT_SUB_TENANT_COLLECTION_FILTERS,
  DEFAULT_TENANT_COLLECTION_FILTERS,
} from '../../../../common/utils/collectionConstants';
import ShowLookupField from './ShowLookupField';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';
import CommonModalComponent from '../../../common/CommonModalComponent';
import { createSelectOptionsForSortField } from './query-util';
import EditFilterDetails from './EditFilterDatails';
export default class QueryDetails extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    showQuery: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
  };

  state = {
    isEditQueryFilter: false,
    openManageReference: false,
    enableLookup: !!this.props.filter.enableLookup,
    showmodal: false,
  };
  toggleModal = () => {
    this.setState({ showmodal: !this.state.showmodal });
  };

  toggleManageReference = () => {
    this.setState({ openManageReference: !this.state.openManageReference });
  };

  enableUpdateQueryFilter = () => {
    this.setState({ isEditQueryFilter: true });
  };

  disableUpdateQueryFilter = () => {
    this.setState({ isEditQueryFilter: false });
  };

  updateQueryFilter = (finalFilterObj) => {
    this.props.actions.updateQueryOfCollection(finalFilterObj);
    this.disableUpdateQueryFilter();
  };
  enableLookupSetting = () => {
    const { filter, collection, projectId, version, actions } = this.props;
    actions
      .enableLookupSetting({
        projectId,
        version,
        collectionUuid: collection.uuid,
        finderId: filter.uuid,
        enableLookup: !this.state.enableLookup,
      })
      .then(() => this.setState({ enableLookup: !this.state.enableLookup }));
  };
  parseCollectionView = () => {
    const filter_items = this.props.collections.filter_items;
    if (!filter_items) {
      return 'No Record';
    }
    return (
      <ReactJson
        name={false}
        iconStyle={'triangle'}
        enableClipboard={true}
        src={filter_items}
        theme="solarized"
        collapsed={true}
      />
    );
  };

  handleLookupChange = (lookups) => {
    const enabledKeys = Object.keys(lookups).filter((lookup) => lookups[lookup] === true);
    const enabledLookups = [];
    enabledKeys.forEach((lookupKey) => {
      let key = lookupKey;
      if (lookupKey.includes('.')) {
        key = lookupKey.split('.')[0];
      }
      const existingLookup = enabledLookups.find((lookup) => lookup.collectionName === key);
      if (!existingLookup) {
        let key = '';
        if (lookupKey.includes('.')) {
          const keys = lookupKey.split('.');
          enabledLookups.push({
            collectionName: keys[0],
            childLookups: [{ collectionName: keys[1] }],
          });
        } else {
          enabledLookups.push({ collectionName: lookupKey, childLookups: [] });
        }
      } else {
        if (lookupKey.includes('.')) {
          const keys = lookupKey.split('.');
          if (!existingLookup.childLookups.includes(keys[1])) {
            existingLookup.childLookups.push({ collectionName: keys[1] });
          }
        }
      }
    });
    const { filter, collection, projectId, version, actions } = this.props;
    actions.updateLookup({
      projectId,
      version,
      collectionUuid: collection.uuid,
      finderId: filter.uuid,
      enabledLookups,
    });
  };

  handleDelete = () => {
    const { filter, collection, projectId, version, actions, rls } = this.props;
    const preConfirm = () => {
      if (rls) {
        actions.deleteRowLevelSecurityFilter({
          projectId,
          version,
          collectionUuid: collection.uuid,
          rlsFilterId: filter.uuid,
        });
      } else {
        actions.deleteCollectionQuery({
          projectId,
          version,
          collectionUuid: collection.uuid,
          finderId: filter.uuid,
        });
      }
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showRLSFilterName = (filterId) => {
    const { collection } = this.props;
    if (
      !collection ||
      !Array.isArray(collection.rowLevelSecurityFilter) ||
      !collection.rowLevelSecurityFilter.length
    ) {
      return '';
    }
    const rlsFilter = collection.rowLevelSecurityFilter.find(
      (rlsFilter) => rlsFilter.uuid === filterId,
    );
    if (rlsFilter && rlsFilter.name) {
      return rlsFilter.name;
    }
    return '';
  };

  showEditQueryFilter = () => {
    const {
      filter,
      showQuery,
      collection,
      collections,
      projectId,
      version,
      showFilterDeleteLoader,
      sortBy,
      orderBy,
      selectOrderBy,
      actions,
    } = this.props;
    const { projectCollections } = collections;
    const { enableLookup, isEditQueryFilter, openManageReference } = this.state;
    let collectionFields = createSelectOptionsForSortField(collection.fields);
    if (isEditQueryFilter) {
      return (
        <EditQueryFilter
          filter={filter}
          showQuery={showQuery}
          sortBy={sortBy}
          orderBy={orderBy}
          selectOrderBy={selectOrderBy}
          collection={collection}
          projectId={projectId}
          version={version}
          updateQueryFilter={this.updateQueryFilter}
          disableUpdateQueryFilter={this.disableUpdateQueryFilter}
        />
      );
    } else {
      const { flag, rls } = this.props;
      return (
        <Fragment>
          <div className="col-12">
            <p>
              <b> Name&nbsp;: </b>&nbsp; {filter.name}
            </p>
            {!rls && (
              <>
                <p>
                  <b>Sort By&nbsp;:</b>&nbsp; {filter.sortBy}
                </p>
                <p>
                  <b>Order BY&nbsp;:</b>&nbsp; {filter.orderBy}
                </p>
              </>
            )}
            <p>
              <b> Query&nbsp;: </b> &nbsp;{showQuery(filter)}
            </p>
            <p>
              <b>Is Private&nbsp;:</b>&nbsp; {filter.isPrivate ? 'true' : 'false'}
            </p>
            <p>
              <b>Add Tenant Query&nbsp;:</b>&nbsp; {filter.addTenantQuery ? 'true' : 'false'}
            </p>
            <p>
              <b>Add Sub Tenant Query&nbsp;:</b>&nbsp; {filter.addSubTenantQuery ? 'true' : 'false'}
            </p>

            {!rls && (
              <>
                <p>
                  <b>Enable RLS&nbsp;:</b>&nbsp; {filter.enableRls ? 'true' : 'false'}
                </p>
                {filter.enableRls && (
                  <p>
                    <b>RLS Filter&nbsp;:</b>&nbsp; {this.showRLSFilterName(filter.rlsFilter)}
                  </p>
                )}
              </>
            )}
          </div>
          <Modal
            size="lg"
            isOpen={openManageReference}
            toggle={this.toggleManageReference}
            backdrop="static"
          >
            <ModalHeader toggle={this.toggleManageReference} className="border-bottom">
              <strong>Update Collection References</strong>
            </ModalHeader>
            <ModalBody>
              <ShowLookupField
                collections={projectCollections}
                collection={collection}
                filter={filter}
                enableLookup={enableLookup}
                enableLookupSetting={this.enableLookupSetting}
                handleLookupChange={this.handleLookupChange}
              />
            </ModalBody>
          </Modal>
          <div className="col-12 text-right pb-2">
            {!rls && (
              <>
                <button
                  type="button"
                  className="btn btn-md btn-theme-warning"
                  onClick={this.toggleManageReference}
                >
                  <i className="wb webconnect-diagram-3-fill"></i> Manage References
                </button>
                {!(
                  DEFAULT_COLLECTION_FILTERS.includes(filter.name) ||
                  DEFAULT_TENANT_COLLECTION_FILTERS.includes(filter.name) ||
                  DEFAULT_SUB_TENANT_COLLECTION_FILTERS.includes(filter.name)
                ) && (
                  <button
                    type="button"
                    className="btn btn-md btn-theme-submit"
                    title="Edit Filter"
                    onClick={() => this.toggleModal()}
                  >
                    <i className="wb webconnect-pencil" />
                    &nbsp;Edit
                  </button>
                )}
              </>
            )}
            {!(
              DEFAULT_COLLECTION_FILTERS.includes(filter.name) ||
              DEFAULT_TENANT_COLLECTION_FILTERS.includes(filter.name) ||
              DEFAULT_SUB_TENANT_COLLECTION_FILTERS.includes(filter.name)
            ) && (
              <button
                type="button"
                className="btn btn-md btn-theme-delete mr-1"
                onClick={flag ? this.handleDelete : undefined}
                disabled={showFilterDeleteLoader}
                style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
              >
                <i className="wb webconnect-trash-regular"></i> Delete&nbsp;
                {flag ? null : (
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                )}
                <CustomLoader loading={showFilterDeleteLoader} />
              </button>
            )}
          </div>
          <CommonModalComponent
            showModal={this.state.showmodal}
            toggleModal={this.toggleModal}
            modalHeader={'Update Filter'}
            modalSize={'modal-lg'}
          >
            <EditFilterDetails
              filter={filter}
              collectionFields={collectionFields}
              version={version}
              projectId={projectId}
              collection={collection}
              actions={actions}
              toggleModal={this.toggleModal}
            />
          </CommonModalComponent>
        </Fragment>
      );
    }
  };

  render() {
    return <div className="row pt-2">{this.showEditQueryFilter()}</div>;
  }
}
